module.exports = __webpack_public_path__ + "static/footer-bg0-6b5cd79bcecba40c268fe77aa5679772.jpg";